import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Html5QrcodePlugin from "../scanner/Html5QRCodeScanner";

export type DecodedResult = {
  decodedText: string;
  result: {
    text: string;
    format: {
      formatName: string;
    };
  };
};

interface IScannerModalProps {
  showScanner: boolean;
  scannerToggle: () => void;
  onScanResult: (result: string, decodedResult: DecodedResult) => void;
}
function ScannerModal(props: IScannerModalProps) {
  return (
    <div>
      <Modal isOpen={props.showScanner} toggle={props.scannerToggle}>
        <ModalHeader toggle={props.scannerToggle}>Escanear rollo</ModalHeader>
        <ModalBody>
          <Html5QrcodePlugin
            fps={10}
            qrbox={250}
            disableFlip={false}
            qrCodeSuccessCallback={props.onScanResult}
          />
        </ModalBody>
      </Modal>
    </div>
  );
}

export default ScannerModal;
